import { create } from 'zustand';
import { CURRENCIES } from '../config/constants';
import { immerMiddleware } from '../services/Utils';

export const defaultQuotation = {
  uuid: '',
  id: '',
  name: '',
  date: '',
  dueDate: '',
  tax: '',
  discount: '',
  type: '',
  currency: CURRENCIES.INR,
  terms: '',
  description: '',
  quotationId: '',
  quotationUuid: '',
  clientUuid: '',
  paymentUuid: '',
  locationUuid: '',
  amountPercentage: '',
  billingAddress: '',
  shippingAddress: '',
  status: 'Created',
  preferences: { showTerms: false, showPayment: false, showDescription: false },
  items: [{ name: '', quantity: '', price: '', tax: '', discount: '' }]
};

const quotationsStore = set => ({
  quotation: defaultQuotation,
  setQuotation: quotation => {
    set(state => {
      state.quotation = quotation;
    });
  },
  setType: type => {
    set(state => {
      state.quotation.type = type;
    });
  },
  setId: id => {
    set(state => {
      state.quotation.id = id;
    });
  },
  setName: name => {
    set(state => {
      state.quotation.name = name;
    });
  },
  setDate: date => {
    set(state => {
      state.quotation.date = date;
    });
  },
  setDueDate: date => {
    set(state => {
      state.quotation.dueDate = date;
    });
  },
  setCurrency: currency => {
    set(state => {
      state.quotation.currency = currency;
    });
  },
  setQuotationId: id => {
    set(state => {
      state.quotation.quotationId = id;
    });
  },
  setAmountPercentage: amountPercentage => {
    set(state => {
      state.quotation.amountPercentage = amountPercentage;
    });
  },
  setQuotationUuid: quotationUuid => {
    set(state => {
      state.quotation.quotationUuid = quotationUuid;
    });
  },
  setClient: clientUuid => {
    set(state => {
      state.quotation.clientUuid = clientUuid;
    });
  },
  setBillingAddress: address => {
    set(state => {
      state.quotation.billingAddress = address;
    });
  },
  setShippingAddress: address => {
    set(state => {
      state.quotation.shippingAddress = address;
    });
  },
  setStatus: status => {
    set(state => {
      state.quotation.status = status;
    });
  },
  setPayment: paymentUuid => {
    set(state => {
      state.quotation.paymentUuid = paymentUuid;
    });
  },
  setLocation: locationUuid => {
    set(state => {
      state.quotation.locationUuid = locationUuid;
    });
  },
  setTerms: terms => {
    set(state => {
      state.quotation.terms = terms;
    });
  },
  setDescription: description => {
    set(state => {
      state.quotation.description = description;
    });
  },
  setShowDescription: showDescription => {
    set(state => {
      state.quotation.preferences.showDescription = showDescription;
    });
  },
  setShowPayment: showPayment => {
    set(state => {
      state.quotation.preferences.showPayment = showPayment;
    });
  },
  setShowTerms: showTerms => {
    set(state => {
      state.quotation.preferences.showTerms = showTerms;
    });
  },
  addItem: item => {
    set(state => {
      state.quotation.items.push(item);
    });
  },
  updateItem: (item, index) => {
    set(state => {
      state.quotation.items.splice(index, 1, item);
    });
  },
  deleteItem: index => {
    set(state => {
      state.quotation.items.splice(index, 1);
    });
  }
});

export const useQuotationsStore = create(immerMiddleware(quotationsStore));
